












































import {
  defineComponent,
  onMounted,
  PropType,
  ref,
  useFetch,
  useRouter,
} from "@nuxtjs/composition-api";
import { useUiHelpers } from "~/composables";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import { SortingModel } from "~/modules/catalog/category/composables/useFacet/sortingOptions";
import type { RemovableFilterInterface } from "~/modules/catalog/category/components/filters/useFilters";

export default defineComponent({
  components: {
    SkeletonLoader,
  },
  props: {
    sortBy: {
      type: Object as PropType<SortingModel>,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    removableFilters: {
      type: Array as PropType<RemovableFilterInterface[]>,
      default: () => [],
    },
  },
  setup(_, { emit }) {
    const router = useRouter();
    const uiHelpers = useUiHelpers();
    const doChangeSorting = (sort: string) => {
      uiHelpers.changeSorting(sort, false);
      emit("reloadProducts");
    };

    const isFilterNavbarOpen = ref(false);
    const sortValue = ref(null);

    onMounted(() => {
      initSortValue();
    });

    const initSortValue = () => {
      let routerQuery;
      if (process?.client) {
        routerQuery = router?.resolve(
          (window?.location?.pathname + window?.location?.search)?.slice(1)
        )?.route?.query;
      } else {
        routerQuery = router?.currentRoute?.query;
      }

      if (routerQuery?.sort) {
        sortValue.value = routerQuery.sort;
      } else {
        sortValue.value = null;
      }
    };

    const changeSortOderValue = (value: string) => {
      sortValue.value = value;
      doChangeSorting(value);
      setTimeout(() => {
        offFilterNavbar();
      }, 1000);
    };

    const offFilterNavbar = () => {
      isFilterNavbarOpen.value = false;
    };

    const toggleFilterNavbar = () => {
      isFilterNavbarOpen.value = !isFilterNavbarOpen.value;
    };

    const OpenFilterMobile = () => {
      emit("openFilterMobile");
    };

    return {
      sortValue,
      doChangeSorting,
      ...uiHelpers,
      changeSortOderValue,
      offFilterNavbar,
      isFilterNavbarOpen,
      toggleFilterNavbar,
      OpenFilterMobile,
      initSortValue,
    };
  },
});
